import AxiosClient from './clients/axios'

const resource = 'integrations/mobly/services/cs'

const find = () => AxiosClient(true).get(`${resource}/warnings`)

export {
  find
}
